export default [
  {
    itemType: 'group',
    colCount: 2,
    items: [
      {
        itemType: 'group',
        colCount: 1,
        items: [
          {
            dataField: 'descricao',
            label: { text: 'Descrição' },
            validationRules: [{
              type: 'required',
              message: 'Descrição é obrigatório'
            }]
          },
          {
            template: 'templateTela'
          }
        ]
      },
      {
        template: 'templateFuncionalidade'
      }
    ]
  }
]
